import { useMutation } from 'react-query';

import Api, { setAccessToken } from '../../api/api';

export type SignUpToEventDto = {
  eventId: string;
  fullname: string;
  phone: string;
  email: string;
  code: string;
};

const formatPhoneNumber = (phone: string): string => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // If it's a 10-digit US number without country code, add +1
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  }

  // If it's a 11-digit US number starting with 1, add +
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `+${cleaned}`;
  }

  // If it already starts with +1, return as is
  if (cleaned.startsWith('1') && phone.startsWith('+1')) {
    return phone;
  }

  // For any other format, return the original
  return phone;
};

export const webSignUpToEvent = async (params: SignUpToEventDto) => {
  const { eventId, fullname, phone, email, code } = params;
  const formattedPhone = formatPhoneNumber(phone);

  const [response, bodyOrError] = await Api.post(`events/${eventId}/web-sign-up`, {
    fullname,
    phone: formattedPhone,
    email: email.trim(),
    code,
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  if (bodyOrError?.accessToken && bodyOrError?.refreshToken) {
    setAccessToken(bodyOrError.accessToken, bodyOrError.refreshToken);
  }

  return bodyOrError;
};

export const useWebSignUpToEvent = () => {
  return useMutation((params: SignUpToEventDto) => webSignUpToEvent(params));
};
